import van from "vanjs-core";
import {DateAndTimeFooter} from "../../components/date-and-time";
import {SmallTagWithDescriptions} from "../../components/small-tag-with-description";
import {Logos} from "../../components/logos";
import {temperature} from "../../state-variables";

const {div, span, img} = van.tags;



// Footer na 1. obrazovce
export const Footer = () => {
    return div({class: "footer d-flex flex-row align-items-center mt-auto justify-content-between"},
        div({class: "reactive-displays"},
            DateAndTimeFooter,
            SmallTagWithDescriptions("Venkovní teplota", "Ambient Temperature", temperature, "°C"),
        ),
        Logos,
    )
}